<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<adicionar-items-lista-adicionales #appvaloresposiblesmodal (ConfirmoUsuario)="SeleccionoValoresPosibles($event)"></adicionar-items-lista-adicionales>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">{{tituloForma}}</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <mat-tab-group class="tabcontroldatos" mat-align-tabs="start" #tabGroup>
        <mat-tab>
            <ng-template mat-tab-label>
                <span>Datos</span>
            </ng-template>
            <div [formGroup]="form" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off">
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Configuración activa (*)</mat-label>
                        <mat-select formControlName="configuracionActiva" [disabled]="this.form.get('id').value === 0">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaEstado">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Aliado (*)</mat-label>
                        <mat-select formControlName="aplicacion">
                            <mat-option [value]="item.idAplicacion" *ngFor="let item of this.listaDatosAplicaciones">{{item.nombre}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Cliente (*)</mat-label>
                        <input matInput formControlName="clienteCarga" autocomplete="off">
                        <mat-error *ngIf="form.get('clienteCarga').hasError('required')">El cliente es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('clienteCarga').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Canal (*)</mat-label>
                        <input matInput formControlName="archivoCarga" autocomplete="off">
                        <mat-error *ngIf="form.get('archivoCarga').hasError('required')">El Canal es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('archivoCarga').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Programa (*)</mat-label>
                        <input matInput formControlName="archivoProducto" autocomplete="off">
                        <mat-error *ngIf="form.get('archivoProducto').hasError('required')">El programa es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('archivoProducto').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Columna Nro Identificación (*)</mat-label>
                        <input matInput formControlName="columnaIdentificacion" autocomplete="off">
                        <mat-error *ngIf="form.get('columnaIdentificacion').hasError('required')">La Columna Nro Identificación es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('columnaIdentificacion').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Columna Nombre (*)</mat-label>
                        <input matInput formControlName="columnaNombre" autocomplete="off">
                        <mat-error *ngIf="form.get('columnaNombre').hasError('required')">La Columna Nombre es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('columnaNombre').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Columna Apellido</mat-label>
                        <input matInput formControlName="columnaApellido" autocomplete="off">
                        <mat-error *ngIf="form.get('columnaApellido').hasError('required')">La Columna Apellido es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('columnaApellido').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Columna Registro único</mat-label>
                        <input matInput formControlName="columnaRegistroUnico" autocomplete="off">
                        <mat-error *ngIf="form.get('columnaRegistroUnico').hasError('required')">La Columna Registro único es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('columnaRegistroUnico').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Columna Fecha inicial (*)</mat-label>
                        <input matInput formControlName="columnaFechaInicial" autocomplete="off">
                        <mat-error *ngIf="form.get('columnaFechaInicial').hasError('required')">La Columna Fecha inicial es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('columnaFechaInicial').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Columna Fecha final (*)</mat-label>
                        <input matInput formControlName="columnaFechaFinal" autocomplete="off">
                        <mat-error *ngIf="form.get('columnaFechaFinal').hasError('required')">La Columna Fecha final es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('columnaFechaFinal').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Columnas adicionales visualizar</mat-label>
                        <input matInput formControlName="columnasVisualizar" autocomplete="off" [readonly]="true">
                        <button matSuffix mat-icon-button (click)="EditarParametroValoresPosiblesAdicionalesVisualizar()">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <mat-error *ngIf="form.get('columnasVisualizar').hasError('required')">Las Columnas adicionales visualizar es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('columnasVisualizar').hasError('maxlength')">La longitud máxima es 5000</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Mostrar beneficiarios</mat-label>
                        <mat-select formControlName="mostrarBeneficiarios">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaEstado">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12" *ngIf="this.form.get('mostrarBeneficiarios').value">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Columnas beneficiarios (*)</mat-label>
                        <input matInput formControlName="columnasBeneficiarios" autocomplete="off" [readonly]="true">
                        <button matSuffix mat-icon-button (click)="EditarParametroValoresPosiblesColumnasBeneficiarios()">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <mat-error *ngIf="form.get('columnasBeneficiarios').hasError('required')">Las Columnas beneficiarios es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('columnasBeneficiarios').hasError('maxlength')">La longitud máxima es 5000</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Terminos y condiciones</mat-label>
                        <input matInput formControlName="rutaTerminosCondiciones" autocomplete="off">
                        <mat-error *ngIf="form.get('rutaTerminosCondiciones').hasError('required')">La Columna Terminos y condiciones es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('rutaTerminosCondiciones').hasError('maxlength')">La longitud máxima es 500</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <div class="d-flex flex-row-reverse pr-0">
        <div *ngIf="this.tamanoAppService.mostrarModoEscritorio">
            <button mat-button class="botonguardardatos" (click)="Guardar()" [disabled]="mostrarCargando">
                <div class="d-flex flex-row-reverse">
                    <mat-icon class="botonguardardatosicono">check_circle_outline</mat-icon>
                    <span class="botonguardardatostexto">{{tituloBoton}}</span>
                </div>
            </button>
        </div>
    </div>
</div>